// removed by extract-text-webpack-plugin
module.exports = {"tooltipWrapper":"tooltip-module__tooltipWrapper___3dQ5P","tooltip":"tooltip-module__tooltip___zRBWm","tooltipInner":"tooltip-module__tooltipInner___bH9o2","tooltipInnerTop":"tooltip-module__tooltipInnerTop___3rGLd","tooltipContentText":"tooltip-module__tooltipContentText___uLMXa","tooltipInnerButton":"tooltip-module__tooltipInnerButton___19w8d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tooltip/tooltip.module.scss
// module id = 158
// module chunks = 0